<template>
  <section class="form-list">
    <el-form class="form form-max" ref="form" label-width="80px">
      <el-form-item label="课程门店">
        <span class="title">{{course.store_name}}</span>
      </el-form-item>

      <el-form-item label="课程名称">
        <span class="title">{{course.course_name}}</span>
      </el-form-item>

      <el-form-item label="所属专栏">
        <router-link v-if="course.course_column_id" :to="RouteConfig.courseColumnManage.to(course.course_column_id)" class="primary-color">{{ courseColumn.course_column_name }}</router-link>
        <span v-else class="info-color">暂未设置专栏</span>
      </el-form-item>

      <el-form-item label="单独预约">
        <template v-if="course.course_column_id">
          <span v-if="courseColumn.is_reservable_solo" class="primary-color">是，已开启单独预约</span>
          <span v-else class="danger-color">否，不可单独预约</span>
        </template>
        <span v-else class="info-color">未设置专栏，默认可约</span>
      </el-form-item>

      <el-form-item label="课程老师">
        <div class="flex">
          <template v-for="(v, i) in course.teachers">
            <v-avatar-nickname
              :key="'t' + i"
              :value="v.avatar"
              :nickname="v.nickname"
              class="avatar-item"
              width=""
            />
            <template v-if="v.sub_teacher_id">
              <i :key="'arrow' + i" class="icon-arrow-right avatar-item" />
              <v-avatar-nickname
                :key="'sub' + i"
                :value="v.sub_avatar"
                :nickname="v.sub_nickname"
                class="avatar-item"
                width=""
              />
            </template>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="课程时间">
        <span class="title">{{course.date}} {{course.start_time}} ~ {{course.end_time}}</span>
      </el-form-item>

      <template v-if="!course.is_show_free && course.decrement_number">
        <el-form-item label="次卡扣次">
          <span class="title">
            <span class="primary-color count-number sign-in-count">{{ course.decrement_number | toYuan }}</span> 次
          </span>
        </el-form-item>

        <el-form-item label="通卡扣天">
          <span class="title">
            <span class="primary-color count-number sign-in-count">{{ course.decrement_days | toYuan }}</span> 天
          </span>
        </el-form-item>
      </template>
      <el-form-item v-else label="预约方式">
        <span v-if="course.is_show_free" class="title">
          <el-tag type="warning" size="small" class="reserve-mode-tag">不鸽费预约</el-tag>
          <template v-if="course.price">押金 <b class="primary-color">{{ course.price | toYuan }}</b> 元，学员签到后由后台发起退款</template>
          <span v-else class="info-color">未设置押金金额</span>
        </span>
        <span v-else class="title">
          <el-tag type="success" size="small" class="reserve-mode-tag">免费预约</el-tag>
          不扣课卡、不收费，学员直接报名
        </span>
      </el-form-item>

      <el-form-item label="预约上限">
        <span class="title">
          <span class="primary-color count-number sign-in-count">{{course.student_number}}</span> 人
        </span>
      </el-form-item>

      <el-form-item class="last-form-item" label="人数统计">
        <div class="count-box">
          <div>已预约</div> <span class="count-number">{{ course.student_count || 0 }}</span> 人，
          已试课 <span class="count-number">{{ course.trial_count || 0 }}</span> 人，
          已签到 <span class="primary-color count-number sign-in-count">{{ course.signed_count || 0 }}</span>
          <span class="button-margin">人</span>

          <v-list-button class="flex-box" icon="signed-in" name="签到" :to="courseReserveTo(id)"/>
          <v-list-button class="flex-box" icon="trial" name="试课" :to="courseTrailTo(id)"/>
          <v-list-button class="flex-box" icon="edit" name="修改课程" size="large" :to="courseEditTo(id)"/>
          <v-list-button icon="mini-app-qr-code" name="小程序码" size="large" @click="getQrCode(id)" :is-loading="isGetting[id]"/>
          <v-list-button icon="queue-canceled" name="导出 Excel" size="large" @click="exportExcel(xlsData, '预约名单')"/>
        </div>
      </el-form-item>
    </el-form>

    <v-table
      :count="count"
      :list="course.students"
      :is-loading="isLoading"
      :push-list="courseManagePush"
      default-order-by="sign_in_time"
      :query-list="queryList"
      :is-hide-filter="true"
      :is-not-top-list="true"
    >
      <el-table-column type="expand" v-if="!is2k">
        <template v-slot="{ row }">
          <el-form label-position="left" inline class="table-expand">
            <el-form-item label="签到时间">
              <span>{{ row.sign_in_time | timeToYmdHi }}</span>
            </el-form-item>
            <el-form-item label="预约时间">
              <span>{{ row.reserve_time | timeToYmdHi }}</span>
            </el-form-item>
            <el-form-item label="排队时间">
              <span>{{ row.queue_time | timeToYmdHi }}</span>
            </el-form-item>
            <el-form-item label="所属学员">
              <v-avatar-nickname
                :value="row.selfie"
                :nickname="row.student_name"
                :is-center="true"
                :nickname-overflow="true"
                :link-page-name="studentDetailName"
                :link-page-id="row.id"
                :avatar-size="50"
              />
            </el-form-item>
            <el-form-item label="课卡/课次券">
              <span v-if="row.card_id">{{ row.card_name }}</span>
              <span v-else-if="row.card_ticket_id">{{ row.card_ticket_type_name }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="身份证号">
              <span v-if="row.id_number">{{ row.id_number }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="扣卡次数">
              <span v-if="row.card_ticket_id || (row.card_id && row.is_number_limit)">{{ row.decrement_number | toYuan }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="扣卡天数">
              <span v-if="row.card_id && !row.is_number_limit">{{ row.decrement_days | toYuan }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="剩余次数">
              <span v-if="row.card_ticket_id || (row.card_id && row.is_number_limit)">{{ (row.card_id ? row.expire_number : row.expire_number_ticket) | toYuan }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="失效日期">
              <span>{{ (row.card_id ? row.expire_time : row.expire_time_ticket) | timeToYmd }}</span>
            </el-form-item>
            <el-form-item label="微信支付订单号">
              <span v-if="row.we_chat_order_id">{{ row.out_trade_no }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="实际支付金额">
              <span v-if="row.we_chat_order_id">{{ row.payer_total | toYuan }} 元</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="退款金额">
              <span v-if="row.we_chat_order_id">{{ row.payer_refund | toYuan }} 元</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="退款状态">
              <template v-if="row.refund_id">
                <el-tag v-if="row.is_reject" type="danger">申请失败</el-tag>
                <template v-else>
                  <el-tag v-if="!row.status">申请中</el-tag>
                  <template v-else>
                    <el-tag
                      v-for="refundState in findRefundState(row.status)"
                      :key="`refundState${row.refund_id}${refundState.value}`"
                      :type="refundState.tagType"
                    >
                      {{ refundState.name }}
                    </el-tag>
                  </template>
                </template>
              </template>
            </el-form-item>
            <el-form-item label="预约状态">
              {{ (course.decrement_number && !row.card_id && !row.card_ticket_id && !row.we_chat_order_id) ? '试课' : getReservationNameByState(row.reserve_state) }}
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <v-column-time value="签到时间" field="sign_in_time" v-if="isPc"/>
      <v-column-time value="预约时间" field="reserve_time"/>

      <el-table-column label="排队时间" v-if="is2k">
        <template v-slot="{ row }">
          <span>{{ row.queue_time | timeToYmdHi }}</span>
        </template>
      </el-table-column>

      <v-column-student label="所属学员" link-page-id="student_id"/>

      <el-table-column label="支付金额" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.payer_total | toYuan }} 元</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="课卡/课券">
        <template v-slot="{ row }">
          <span v-if="row.card_id">{{ row.card_name }}</span>
          <span v-else-if="row.card_ticket_id">{{ row.card_ticket_type_name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="身份证号" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.id_number">{{ row.id_number }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="扣卡天数" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.card_id && !row.is_number_limit">{{ row.decrement_days | toYuan }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="所扣次数" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.card_ticket_id || (row.card_id && row.is_number_limit)">{{ row.decrement_number | toYuan }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="失效日期">
        <template v-slot="{ row }">
          {{ (row.card_id ? row.expire_time : row.expire_time_ticket) | timeToYmd }}
        </template>
      </el-table-column>

      <el-table-column label="剩余次数">
        <template v-slot="{ row }">
          <span v-if="row.card_ticket_id || (row.card_id && row.is_number_limit)">{{ (row.card_id ? row.expire_number : row.expire_number_ticket) | toYuan }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="微信支付订单号" width="140" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.out_trade_no }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="退款金额" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.payer_refund | toYuan }} 元</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="退款状态" v-if="is2k">
        <template v-slot="{ row }">
          <template v-if="row.refund_id">
            <el-tag :type="row.refund_tag_type">{{ row.refund_state_name }}</el-tag>
          </template>
        </template>
      </el-table-column>

      <el-table-column label="预约状态" prop="reserve_state_name"/>

      <el-table-column label="操作" width="504px">
        <template v-slot="{ row }">

          <v-list-button
            name="发起退款"
            icon="queue-canceled"
            size="large"
            v-if="isAdministrator && (row.reserve_state === reserveStates.signedIn.value || row.reserve_state === reserveStates.signBroken.value) && row.we_chat_order_id && (!row.refund_id || (row.refund_id && row.is_reject))"
            @click="handleApplyRefund(row)"
            :is-loading="isRefundingIds.includes(row.id)"
            message="向微信申请发起退款后，本课程所支付费用将原路退还，但不会影响预约状态，确认要继续吗？"
          />

          <v-list-button
            v-if="isSignStates(row.reserve_state) && (row.card_id || row.card_ticket_id)"
            name="设为爽约"
            icon="sign-broken"
            size="large"
            @click="handleChangeToSignBroken(row)"
            :is-loading="isBrokingIds.includes(row.id)"
            message="该预约状态设为爽约后，将扣除该学员签到所得积分，确认要继续吗？"
          />

          <v-list-button
            v-if="row.reserve_state === reserveStates.signedIn.value && !row.course_column_id"
            name="取消签到"
            icon="sign-canceled"
            size="large"
            :is-last="true"
            @click="handleCancelSignIn(row)"
            :is-loading="isCancellingIds.includes(row.id)"
            message="取消此次签到后，将返还预约所扣次数并扣除签到所得积分，确认要继续吗？"
          />

          <v-list-button
            v-if="row.reserve_state === reserveStates.waitSignIn.value"
            name="设为签到"
            icon="signed-in"
            size="large"
            @click="handleSignIn(row)"
            :is-loading="isSigningIds.includes(row.id)"
            message="该预约将由待签到状态变化为已签到状态，确认要继续吗？"
          />

          <v-list-button
            v-if="row.reserve_state === reserveStates.waitSignIn.value && !row.course_column_id"
            name="取消预约"
            icon="sign-canceled"
            size="large"
            :is-last="true"
            @click="handleCancelReserve(row)"
            :is-loading="isCancellingIds.includes(row.id)"
            message="取消此次预约后，将返还预约所扣次数，确认要继续吗？"
          />

          <v-list-button
            v-if="row.reserve_state === reserveStates.signBroken.value"
            name="设为签到"
            icon="signed-in"
            size="large"
            @click="signBrokenToSignedIn(row)"
            :is-loading="isSigningIds.includes(row.id)"
            message="该预约将由已爽约状态变化为已签到状态，确认要继续吗？"
          />
        </template>
      </el-table-column>
    </v-table>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import {
  reserveStates,
  getReservationNameByState,
  isSignStates,
  getReservationShortNameByState
} from '@/enums/reserveStates';
import { mapGetters } from 'vuex';
import { show } from '@/api/course';
import { applyRefund } from '@/api/we-chat-order';
import {
  cancelReserve,
  cancelSignIn,
  changeToSignBroken,
  changeToSignedIn,
  signBrokenToSignedIn
} from '@/api/course-reservation';
import { removeArrayItem } from '@/utils';
import getQrCode from '@/views/course/getQrCode';
import { toYuan } from '@/utils/number';
import { refundStates, findRefundState } from '@/enums/refundStates';
import exportExcel from '@/utils/excel-export';
import { timeToYmd, timeToYmdHi } from "@/filters";

export default {
  name: RouteConfig.courseManage.name,
  data: () => ({
    RouteConfig,
    studentDetailName: RouteConfig.studentDetail.name,
    courseManagePush: RouteConfig.courseManage.push,
    courseReserveTo: RouteConfig.courseReserve.to,
    courseEditTo: RouteConfig.courseEdit.to,
    courseTrailTo: RouteConfig.courseTrial.to,
    reserveStates,
    isLoading: false,
    isDeleting: false,
    isGetting: {},
    isBrokingIds: [],
    isCancellingIds: [],
    isSigningIds: [],
    isRefundingIds: [],
    xlsData: [],
    count: 0,
    course: {
      date: '',
      start_time: '',
      end_time: '',
      student_number: '',
      student_count: '',
      signed_count: '',
      trial_count: '',
      wait_count: '',
      course_name: '',
      decrement_number: '',
      decrement_days: 0,
      // 预约方式：is_show_free / price 必须在这里先占位，否则 show() 的 Object.keys 回填会把它们过滤掉
      is_show_free: 0,
      price: 0,
      store_id: 0,
      store_name: '',
      course_column_id: 0,
      course_columns: [],
      teachers: [],
      students: [],
    },
    refundStates,
    queryList: {
      is_asc: 1,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isPc',
      'is2k',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
    courseColumn() {
      return this.course.course_columns[0] || [];
    }
  },
  methods: {
    isSignStates,
    getReservationNameByState,
    getQrCode,
    exportExcel,
    findRefundState,
    computeRefundState(row) {
      row.refund_tag_type = '';
      row.refund_state_name = '';
      if (!row.refund_id) return;
      if (row.is_reject) {
        row.refund_tag_type = 'danger';
        row.refund_state_name = '申请失败';
        return;
      }

      if (!row.status) {
        row.refund_tag_type = 'primary';
        row.refund_state_name = '申请中';
        return;
      }

      const stateList = findRefundState(row.status);
      if (stateList && stateList.length) {
        row.refund_tag_type = stateList[0].tagType;
        row.refund_state_name = stateList[0].name;
      }
    },
    computeReserveStateName(row) {
      row.reserve_state_name = (this.course.decrement_number && !row.card_id && !row.card_ticket_id && !row.we_chat_order_id)
        ? '试课'
        : getReservationShortNameByState(row.reserve_state);
    },
    setXlsData(list) {
      let xlsData = [];
      list.forEach(item => {
        this.computeRefundState(item);
        this.computeReserveStateName(item);
        const isCardOrTicket = item.card_ticket_id || item.is_number_limit;
        xlsData.push({
          '签到时间': timeToYmdHi(item.sign_in_time),
          '预约时间': timeToYmdHi(item.reserve_time),
          '排队时间': timeToYmdHi(item.queue_time),
          '所属学员': item.student_name,
          '所用课卡': item.card_name,
          '身份证号': item.id_number,
          '扣卡次数': isCardOrTicket ? toYuan(item.decrement_number) : '',
          '扣卡天数': isCardOrTicket ? '' : toYuan(item.decrement_days),
          '剩余次数': isCardOrTicket ? toYuan(item.card_id ? item.expire_number : item.expire_number_ticket) : '无限制',
          '失效日期': timeToYmd(item.card_id ? item.expire_time : item.expire_time_ticket),
          '微信支付订单号': item.out_trade_no || '',
          '实际支付金额': item.we_chat_order_id ? toYuan(item.payer_total) : '',
          '退款金额': item.we_chat_order_id ? toYuan(item.payer_refund) : '',
          '退款状态': item.refund_state_name,
          '预约状态': item.reserve_state_name,
        });
      });
      this.xlsData = xlsData;
    },
    async show() {
      const { isError, data } = await show(this.id, 1, 1);
      if (isError) return;

      const { course } = this;
      Object.keys(data).forEach(key => {
        if (key in course) course[key] = data[key];
      });
      if (data.students && data.students.length) this.setXlsData(data.students);
    },
    async handleApplyRefund({ id, we_chat_order_id }) {
      this.isRefundingIds.push(id);
      const postData = {
        course_reservation_id: id,
        we_chat_order_id,
      };
      if (this.isAdministrator) postData.store_id = this.course.store_id;
      const { isError } = await applyRefund(postData);
      removeArrayItem(this.isRefundingIds, id);
      if (!isError) this.show();
    },
    async handleChangeToSignBroken({ id }) {
      this.isBrokingIds.push(id);
      const { isError } = await changeToSignBroken(id);
      removeArrayItem(this.isBrokingIds, id);
      if (!isError) this.show();
    },
    async handleCancelSignIn({ id }) {
      this.isCancellingIds.push(id);
      const { isError } = await cancelSignIn(id);
      removeArrayItem(this.isCancellingIds, id);
      if (!isError) this.show();
    },
    async handleSignIn({ id, student_id }) {
      this.isSigningIds.push(id);
      const { isError } = await changeToSignedIn({
        course_id: this.id,
        student_id,
      });
      removeArrayItem(this.isSigningIds, id);
      if (!isError) this.show();
    },
    async handleCancelReserve({ id }) {
      this.isCancellingIds.push(id);
      const { isError } = await cancelReserve(id);
      removeArrayItem(this.isCancellingIds, id);
      if (!isError) this.show();
    },
    async signBrokenToSignedIn({ id, student_id }) {
      this.isSigningIds.push(id);
      const { isError } = await signBrokenToSignedIn({
        course_id: this.id,
        student_id,
      });
      removeArrayItem(this.isSigningIds, id);
      if (!isError) this.show();
    }
  },
  beforeMount() {
    this.show();
  },
};
</script>

<style scoped>
  .last-form-item {
    margin-bottom: 0;
  }

  .count-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 18px;
  }

  .count-number {
    padding: 0 6px;
    font-weight: bold;
  }

  .sign-in-count {
    font-size: 28px;
    padding-bottom: 2px;
  }

  .avatar-item {
    margin-right: 10px;
  }

  .reserve-mode-tag {
    margin-right: 6px;
    vertical-align: middle;
  }
</style>
